import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=827a1a3a&scoped=true&lang=pug&"
import script from "./Stack.vue?vue&type=script&lang=ts&"
export * from "./Stack.vue?vue&type=script&lang=ts&"
import style0 from "./Stack.vue?vue&type=style&index=0&id=827a1a3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827a1a3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
